import { isAfter, isBefore, isSameDay, isValid, parse } from 'date-fns';
import getTranslation from '../../../helpers/get-translation';
import { AddAuthUserInputType } from '../../../typings';
const stringHasOnlyLetters = (value) => {
    // Match a single character not present in the group [a-zA-Z]
    return !/[^ a-zA-Z]/.test(value);
};
const validateDate = (dateInput) => {
    const regexDate = /^\d{2}\/\d{2}\/\d{4}$/;
    const parsedDate = parse(dateInput, 'MM/dd/yyyy', new Date());
    return !regexDate.test(dateInput) || !isValid(parsedDate);
};
export const validateDateInput = (dob) => {
    const { inputErrorTypeText } = getTranslation();
    if (validateDate(dob)) {
        return inputErrorTypeText.authorizedUserInvalidBirthDate;
    }
    const parsedDate = parse(dob, 'MM/dd/yyyy', new Date());
    const oldestDate = new Date(1900, 0, 1);
    if (isBefore(parsedDate, oldestDate)) {
        return inputErrorTypeText.authorizedUserPastBirthYear;
    }
    if (isAfter(parsedDate, new Date())) {
        return inputErrorTypeText.authorizedUserFutureBirthYear;
    }
    if (isSameDay(parsedDate, new Date())) {
        return inputErrorTypeText.authorizedUserTodayBirthDate;
    }
    return '';
};
const getInputErrorMessage = (type, value) => {
    const { inputErrorTypeText, inputTypeHelpText } = getTranslation();
    if (value.trim() === '') {
        return inputTypeHelpText[type];
    }
    if (type === AddAuthUserInputType.authorizedUserBirthDate) {
        return validateDateInput(value);
    }
    if ((type === AddAuthUserInputType.authorizedUserFirstName ||
        type === AddAuthUserInputType.authorizedUserLastName) &&
        !stringHasOnlyLetters(value)) {
        return inputErrorTypeText[type];
    }
    return '';
};
export default getInputErrorMessage;
